module.exports = __webpack_public_path__ + "img/skin-detail-promo-msu.13f5870.jpg";